const mainNavItems = [
  {
    path: "/",
    label: { ja: "剣道", zh: "剑道", en: "Kendo" },
  },
  {
    path: "/KendouPage/analyzer",
    label: { ja: "動作分析", zh: "动作分析", en: "Motion Analyzer" },
  },
  {
    path: "/english",
    label: { ja: "英語", zh: "英语", en: "English" },
  },
  {
    path: "/fivecirclebook",
    label: { ja: "五輪書", zh: "五轮书", en: "Book of Five Rings" },
  },
  {
    path: "/about",
    label: { ja: "このサイト", zh: "关于本站", en: "About" },
  },
];

const kendouNavItems = [
  {
    path: "/KendouPage/terminology?section=portal",
    label: { ja: "剣道ポータル", zh: "剑道门户", en: "Kendo Portal" },
  },
  {
    path: "/KendouPage/terminology?section=series",
    label: { ja: "シリーズ", zh: "系列", en: "Series" },
  },
  {
    path: "/KendouPage/terminology?section=topics",
    label: { ja: "トピック", zh: "主题", en: "Topics" },
  },
  {
    path: "/KendouPage/terminology?section=techniques&view=knowledge",
    label: { ja: "知識", zh: "知识", en: "Knowledge" },
  },
  {
    path: "/KendouPage/terminology?section=terms",
    label: { ja: "剣道用語", zh: "剑道术语", en: "Terms" },
  },
  {
    path: "/KendouPage/analyzer",
    label: { ja: "動作分析", zh: "动作分析", en: "Motion Analyzer" },
  },
];

const englishNavItems = [
  {
    path: "/english/englishdectionary",
    label: { ja: "英語ポータル", zh: "英语门户", en: "English Portal" },
  },
  {
    path: "/english/practice",
    label: { ja: "練習", zh: "练习", en: "Practice" },
  },
  {
    path: "/english/practice/ai",
    label: { ja: "AI語根練習", zh: "AI词根练习", en: "AI Root Practice" },
  },
];

function pickLabel(labelMap, lang) {
  return labelMap?.[lang] || labelMap?.ja || labelMap?.zh || labelMap?.en || "";
}

export function getMainNavItems(lang) {
  return mainNavItems.map((item) => ({
    path: item.path,
    label: pickLabel(item.label, lang),
  }));
}

export function getKendouNavItems(lang) {
  return kendouNavItems.map((item) => ({
    path: item.path,
    label: pickLabel(item.label, lang),
  }));
}

export function getEnglishNavItems(lang) {
  return englishNavItems.map((item) => ({
    path: item.path,
    label: pickLabel(item.label, lang),
  }));
}
